module.exports = __webpack_public_path__ + "static/img/home_icon.352b9d87.svg";